const MODULE_NAME = 'DiagramModule';

export const SET_KEYPAD_NEXT_BUTTON_TABLE_BUBBLE = `${MODULE_NAME}/SET_KEYPAD_NEXT_BUTTON_TABLE_BUBBLE`;
export const NEXT_CELL_BUBBLE_TABLE = `${MODULE_NAME}/NEXT_CELL_BUBBLE_TABLE`;
export const SET_CURRENT_MEASURMENT_TABLE_CELL = `${MODULE_NAME}/SET_CURRENT_MEASURMENT_TABLE_CELL`;
